import * as amplitude from '@amplitude/analytics-browser';
import uuid from 'react-uuid';
import { LOCAL_STORAGE_USER_DATA } from '../constants';

const { REACT_APP_AMPLITUDE_KEY } = process.env;

const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));
let userId;
export const initAmplitude = (uId = uuid()) => {
  try {
    userId = userData && 'email' in userData ? userData.email : uId;
    localStorage.setItem('ampliUID', userId);
    amplitude.init(REACT_APP_AMPLITUDE_KEY, userId);
    // eslint-disable-next-line no-empty
  } catch {}
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  // this is now sent only for free trail users
  try {
    if (
      (userData &&
        'subscriptionDetails' in userData &&
        userData.subscriptionDetails.currentPlan === 'trial') ||
      eventProperties.page === 'Registration page' ||
      eventType === 'Logged in' ||
      eventType === 'Purchase plan'
    ) {
      eventProperties.email =
        userData && 'email' in userData ? userData.email : '';
      amplitude.track(eventType, eventProperties);
    }
    // eslint-disable-next-line no-empty
  } catch {}
};
